(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pde-first-order-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async(event)=>{
 const button=event.target.closest('.pde-welcome-offer__copy');
 if(!button)return;
 if(!navigator.clipboard){button.textContent='WELCOME10';return;}
 try{await navigator.clipboard.writeText('WELCOME10');button.textContent=button.dataset.copiedLabel;setTimeout(()=>{button.textContent=button.dataset.copyLabel;},2000);}catch{button.textContent='WELCOME10';}
});
  } catch(e) { console.error(e); }
})();

})();
